import { Button } from "@/components/button";
import { Icon } from "@/components/icons";
import { Tooltip } from "@/components/tooltip";

type PdfExportButtonProps = {
  onClick: () => void;
  disabled: boolean;
  disabledTooltip?: string;
};

export function PdfExportButton({ onClick, disabled, disabledTooltip }: PdfExportButtonProps) {
  const button = (
    <Button
      hierarchy="tertiary"
      size="sm"
      rightIcon={<Icon name="publish" size={20} />}
      onClick={onClick}
      disabled={disabled}
    >
      Export PDF
    </Button>
  );
  if (!disabled || !disabledTooltip) return button;
  return (
    <Tooltip title={disabledTooltip} align="end">
      {button}
    </Tooltip>
  );
}
